import HomePage from './HomePage.js';
import MembersPage from './MembersPage.js';
import GroupSettingsPage from './GroupSettingsPage.js';
import LicensePage from './LicensePage.js';

export async function registerSharedPages(app) {
    app.registerPage('home', HomePage);
    app.registerPage('group/members', MembersPage);
    app.registerPage('group/settings', GroupSettingsPage);
    app.registerPage('group/billing_package', LicensePage);
}
